import jwt_decode from "jwt-decode";
import setAuthToken from "src/config/api/setAuthToken";
import { API, URL } from "src/config/api";
import { setApiHeaders } from "src/helper";
import {
  SET_CURRENT_USER,
  LOG_OUT_USER,
  SET_USER_ERROR,
  SET_USER_LOADING,
  SET_USER_DATA,
  SET_APP_LOADING,
} from "src/redux/constants";

import { getSingle } from "src/services/api/users";

export const setCurrentUser =
  (token = {}) =>
  async (dispatch) => {
    setAuthToken(token);
    const decoded = jwt_decode(token);

    try {
      const data = await getSingle(decoded.id);

      localStorage.setItem("userToken", token);

      setApiHeaders({
        uid: data.id,
      });
      dispatch({
        type: SET_CURRENT_USER,
        payload: data,
      });

      return Promise.resolve(data);
    } catch (err) {
      if (
        err.response.statusText === "Unauthorized" ||
        err.response.status === 401
      ) {
        dispatch(logoutUser());
      }
      dispatch({
        type: SET_USER_ERROR,
        payload: err.response,
      });
    }
  };

export const updateUser = (data, id) => async (dispatch) => {
  try {
    const response = await API.put(`${URL.users}/${id}`, data);
    dispatch({
      type: SET_USER_DATA,
      payload: response.data.data,
    });
    return Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err.response.data);
  }
};

export const loginUser = (data) => async (dispatch) => {
  try {
    dispatch({
      type: SET_USER_LOADING,
      payload: true,
    });

    const response = await API.post(URL.auth.login, data);

    const { token } = response.data;

    await dispatch(setCurrentUser(token));
  } catch (err) {
    dispatch({
      type: SET_USER_ERROR,
      payload: err.response,
    });
    return Promise.reject(err.response.data);
  }
};

export const logoutUser = () => (dispatch) => {
  dispatch({
    type: SET_APP_LOADING,
    payload: true,
  });

  localStorage.removeItem("userToken");
  localStorage.removeItem("userModelKeys");

  setAuthToken(false);
  dispatch({
    type: LOG_OUT_USER,
  });
  dispatch({
    type: SET_APP_LOADING,
    payload: false,
  });
};
